import { Controller } from '@hotwired/stimulus';

export default class CheckboxFilterController extends Controller {
  static targets = ['card', 'count', 'checkbox']

  preventClose(event) {
    event.stopPropagation()
  }

  filter() {
    const checkedValues = this.checkedLabelIds()

    this.cardTargets.forEach((card) => {
      const labelId = card.dataset.labelId
      const visible = checkedValues.includes(labelId)

      card.classList.toggle('d-none', !visible)
    })

    this.updateCount()
  }

  cardTargetConnected() {
    this.filter()
  }

  updateCount() {
    if (!this.hasCountTarget) return

    const visibleCount = this.cardTargets.filter((card) => !card.classList.contains('d-none')).length
    this.countTarget.textContent = visibleCount
  }

  checkedLabelIds() {
    return this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value)
  }
}
